import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
// import WebflixImg from "../assets/Images/webflix.jpg";
// import IEEEimg from "../assets/Images/IEEE.png";
// import PortfolioImg from "../assets/Images/portfolio.png";
// import NeuroSpringImg from "../assets/Images/NeuroSpring.png";

import { urlFor, client } from "../client";

function Projects() {
    const [projects, setProjects] = useState([]);
    const [freelance, setFreelance] = useState([]);
    const [apps, setApps] = useState([]);

    useEffect(() => {
        const projects_query = '*[_type == "projects"]';
        const freelance_query = '*[_type == "freelance"]';
        const apps_query = '*[_type == "apps"]';

        client
            .fetch(freelance_query)
            .then((freelance) => setFreelance(freelance));
        client.fetch(projects_query).then((projects) => setProjects(projects));
        client.fetch(apps_query).then((apps) => setApps(apps));
    }, []);

    return (
        <div id="projects" className="h-full !pt-12">
            <motion.div
                whileInView={{ y: [50, 0], opacity: [0, 1] }}
                transition={{ duration: 1, ease: "easeInOut" }}
                className="p-3 md:p-5 w-full text-center ">
                <center>
                    <div className="w-fit font-mono font-extrabold text-transparent text-4xl md:text-5xl bg-clip-text bg-gradient-to-r from-[#2424ec] to-[#00d4ff]">
                        Freelance Work
                    </div>
                    <div className="flex flex-wrap object-cover justify-center mt-2">
                        {freelance.map((project, index) => (
                            <a
                                key={index}
                                href={project.link}
                                target="_blank"
                                rel="noopener noreferrer">
                                <motion.div
                                    whileHover={{ scale: 1.04 }}
                                    transition={{
                                        duration: 0.5,
                                        ease: "easeInOut",
                                    }}
                                    className=" md:w-96 m-6 md:p-3 p-2 rounded-2xl bg_blur cursor-pointer">
                                    <img
                                        src={urlFor(project.image).url()}
                                        className="rounded-xl object-cover"
                                        alt=""
                                    />

                                    <div
                                        className={`font-mono font-bold mt-2 text-lg text-red-500`}>
                                        {project.name}
                                    </div>

                                    <p className="text-left text-sm md:text-base p-2 ">
                                        {project.description}
                                    </p>

                                    <button
                                        href
                                        className="bg_blur font-mono text-gray-300 hover:bg-gray-800 rounded-lg w-20 p-1 m-2">
                                        View
                                    </button>
                                </motion.div>
                            </a>
                        ))}

                    </div>
                    <br />
                </center>
            </motion.div>

            <motion.div
                whileInView={{ y: [50, 0], opacity: [0, 1] }}
                transition={{ duration: 1, ease: "easeInOut" }}
                className="p-3 md:p-5 w-full text-center ">
                <center>
                    <div className="w-fit font-mono font-extrabold text-transparent text-4xl md:text-5xl bg-clip-text bg-gradient-to-r from-[#fdbb2d] to-[#fd842de6]">
                        Apps
                    </div>
                    <div className="flex flex-wrap gap-6 justify-center mt-6">
                        {apps.map((project, index) => (
                            <a
                                key={index}
                                href={project.link}
                                target="_blank"
                                rel="noopener noreferrer">
                                <motion.div
                                    whileHover={{ scale: 1.04 }}
                                    transition={{
                                        duration: 0.5,
                                        ease: "easeInOut",
                                    }}
                                    className="flex flex-col justify-between items-center h-full md:w-96 md:p-3 p-2 rounded-2xl bg_blur cursor-pointer">
                                    <div>
                                        <img
                                            src={urlFor(project.image).url()}
                                            className="rounded-xl w-full h-44 object-cover"
                                            alt=""
                                        />

                                        <div
                                            className={`font-mono font-bold mt-2 text-lg text-red-500`}>
                                            {project.name}
                                        </div>

                                        <p className="text-left text-sm md:text-base p-2 ">
                                            {project.description}
                                        </p>

                                    </div>
                                    <button
                                        href
                                        className="bg_blur font-mono text-gray-300 hover:bg-gray-800 rounded-lg w-20 p-1 m-2">
                                        View
                                    </button>
                                </motion.div>
                            </a>
                        ))}
                    </div>

                    <br />
                </center>
            </motion.div>

            <motion.div
                whileInView={{ y: [50, 0], opacity: [0, 1] }}
                transition={{ duration: 1, ease: "easeInOut" }}
                className="p-3 md:p-10 w-full text-center">
                <center>
                    <div className="w-fit font-mono font-extrabold text-transparent text-4xl md:text-5xl bg-clip-text bg-gradient-to-r from-[#FC466B] to-[#8E2DE2]">
                        Projects
                    </div>
                    <div className="flex flex-wrap gap-6 object-cover justify-center mt-6">
                        {projects.map((project, index) => (
                            <a
                                key={index}
                                href={project.link}
                                target="_blank"
                                rel="noopener noreferrer">
                                <motion.div
                                    whileHover={{ scale: 1.04 }}
                                    transition={{
                                        duration: 0.5,
                                        ease: "easeInOut",
                                    }}
                                    className="flex flex-col justify-between items-center md:w-96 md:p-3 p-2 h-full rounded-2xl bg_blur">
                                    <div>
                                        <img
                                            src={urlFor(project.image).url()}
                                            className="rounded-xl w-full h-44 object-cover"
                                            alt=""
                                        />

                                        <div
                                            className={`font-mono font-bold mt-2 text-lg text-red-500`}>
                                            {project.name}
                                        </div>

                                        <p className="text-left text-sm md:text-base p-2 ">
                                            {project.description}
                                        </p>
                                    </div>

                                    <button
                                        href
                                        className="bg_blur font-mono text-gray-300 hover:bg-gray-800 rounded-lg w-20 p-1 m-2 ">
                                        View
                                    </button>
                                </motion.div>
                            </a>
                        ))}
                    </div>
                </center>
            </motion.div>
        </div>
    );
}

export default Projects;
